// Accept slug path like "/explore/grow" or "grow" and extract the final segment
export const extractSlugNameFromPath = (slugPath: string) =>
  slugPath.trim().toLowerCase().split('/').filter(Boolean).pop();
